import React, { useState, useEffect } from 'react';
import axios from 'axios';

function SupplierForm() {
  const [formData, setFormData] = useState({
    leadid: '',
    supplierlist_id: '',
    supplier_name: '',
    total_payable: 0,
    paid_on: '',
    paid_amount: 0,
    comments: '',
    userid: '1', // This should come from your auth system
    username: 'hemanth' // This should come from your auth system
  });
  
  const [balance, setBalance] = useState({
    total_payable: 0,
    total_paid: 0,
    balance: 0
  });
  
  const [history, setHistory] = useState([]);
  
  // Fetch balance and history when leadid or supplierlist_id changes
  useEffect(() => {
    if (formData.leadid && formData.supplierlist_id) {
      // Fetch balance
      axios.get(`http://localhost:5000/api/suppliers/balance/${formData.leadid}/${formData.supplierlist_id}`)
        .then(response => setBalance(response.data))
        .catch(error => console.error(error));
      
      // Fetch history
      axios.get(`http://localhost:5000/api/suppliers/history/${formData.leadid}/${formData.supplierlist_id}`)
        .then(response => setHistory(response.data))
        .catch(error => console.error(error));
    }
  }, [formData.leadid, formData.supplierlist_id]);
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();
    axios.post('http://localhost:5000/api/suppliers', formData)
      .then(response => {
        alert('Supplier entry created successfully!');
        // Refresh history
        if (formData.leadid && formData.supplierlist_id) {
          axios.get(`http://localhost:5000/api/suppliers/history/${formData.leadid}/${formData.supplierlist_id}`)
            .then(response => setHistory(response.data));
        }
      })
      .catch(error => console.error(error));
  };
  
  return (
    <div>
      <h2>Supplier Payment Form</h2>
      <form onSubmit={handleSubmit}>
        <div>
          <label>Lead ID:</label>
          <input 
            type="text" 
            name="leadid" 
            value={formData.leadid} 
            onChange={handleChange} 
            required 
          />
        </div>
        
        <div>
          <label>Supplier List ID:</label>
          <input 
            type="text" 
            name="supplierlist_id" 
            value={formData.supplierlist_id} 
            onChange={handleChange} 
            required 
          />
        </div>
        
        <div>
          <label>Supplier Name:</label>
          <input 
            type="text" 
            name="supplier_name" 
            value={formData.supplier_name} 
            onChange={handleChange} 
            required 
          />
        </div>
        
        <div>
          <label>Total Payable:</label>
          <input 
            type="number" 
            name="total_payable" 
            value={formData.total_payable} 
            onChange={handleChange} 
            required 
          />
        </div>
        
        <div>
          <label>Paid On:</label>
          <input 
            type="date" 
            name="paid_on" 
            value={formData.paid_on} 
            onChange={handleChange} 
          />
        </div>
        
        <div>
          <label>Paid Amount:</label>
          <input 
            type="number" 
            name="paid_amount" 
            value={formData.paid_amount} 
            onChange={handleChange} 
          />
        </div>
        
        <div>
          <label>Comments:</label>
          <textarea 
            name="comments" 
            value={formData.comments} 
            onChange={handleChange} 
          />
        </div>
        
        <button type="submit">Submit</button>
      </form>
      
      <div>
        <h3>Balance Information</h3>
        <p>Total Payable: {balance.total_payable}</p>
        <p>Total Paid: {balance.total_paid}</p>
        <p>Balance: {balance.balance}</p>
      </div>
      
      <div>
        <h3>Payment History</h3>
        <table>
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>Status</th>
              <th>Comments</th>
            </tr>
          </thead>
          <tbody>
            {history.map(item => (
              <tr key={item.id}>
                <td>{new Date(item.created_At).toLocaleDateString()}</td>
                <td>{item.paid_amount}</td>
                <td>{item.status}</td>
                <td>{item.comments}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default SupplierForm;